import { useRouter } from 'next/router';

import { useEffect } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';

export default function SmartSystem() {
    const { t } = useLang('powerstream.detail.powerSmart');
    const { locale } = useRouter();

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.smart-system .plug-img', { y: 0 }, { y: 300 }, 1]],
            triggerElement: '.smart-system',
            offset: '30%',
            duration: '170%',
            triggerHook: 1,
        });
    }, []);

    return (
        <div className={`${styles.smartSystem} smartSystem`}>
            <div className="control-box smart-system">
                <div className="top-box">
                    <p className="title">
                        {t.rich('title', {
                            HighLight: (text: string) => <span className="green-text">{text}</span>,
                        })}
                    </p>
                    <p className="desc">{t('desc')}</p>
                    <div className="img-box">
                        <div className="text-box">
                            <div className="img-text">{t('text')}</div>
                        </div>
                        <div className="plug-img">
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/smart_plug.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/smart_plug.webp')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
